import React, { useContext, useState } from "react";
import { toast } from "react-toastify";

import closeIcon from "../../../../src/assests/img/close-icon.svg";
import AuthManager from "../../../Common/AuthManager";
import { AppContext } from "../../../Context/AppContext";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import GMSButton from "../../Common/components/GMSButton";
import GMSFillButton from "../../Common/components/GMSFillButton";
import "./Connection.css";
import ScheduleForm from "./ScheduleForm";
const MID_WAY_URL = process.env.REACT_APP_CONNECTION_API;

const DataImportForm = (props) => {
  const { setShowImportDataForm, fetchData, gmsEndpoint } = props;
  const [showSchedule, setShowSchedule] = useState(false);
  const [nameType, setNameType] = useState("");
  const [disableButton, setDisableButton] = useState(false);

  const isNewVersion = parseFloat((gmsEndpoint || '').replace('v', '')) >= 3;

  // app context
  const appData = useContext(AppContext);

  const [formData, setFormData] = useState({
    type: "",
    data_type: "",
    user_name: get_logged_User_name(),
  });

  function get_logged_User_name() {
    let userobj = null;
    if (AuthManager.isAuthenticated()) userobj = AuthManager.getAuthUser();
    if (
      userobj === null ||
      userobj === undefined ||
      userobj.profile === null ||
      userobj.profile === undefined
    )
      return "guest";
    return userobj.profile.first_name + " " + userobj.profile.last_name;
  }

  const handleChange = (e) => {
    const { name, value } = e.target;

    const nameTypeMapping = {
      availability: "AVAILABILITY_<YYYYMMDD>_<HHMMSS>.csv",
      products: "PRODUCTS_<YYYYMMDD>_<HHMMSS>.csv",
      prices: "PRICES<YYYYMMDD>_<HHMMSS>.csv",
      invoice: "INVOICE_<YYYYMMDD>_<HHMMSS>.csv",
      ...(isNewVersion
        ? { relatedproducts: "RELATEDPRODUCTS_<YYYYMMDD>_<HHMMSS>.csv" }
        : { accessories: "ACCESSORIES_<YYYYMMDD>_<HHMMSS>.csv" }
      ),
      relatedproducts: "RELATEDPRODUCTS_<YYYYMMDD>_<HHMMSS>.csv",
      orders: "ORDERS_<YYYYMMDD>_<HHMMSS>.csv",
      substitutes: "SUBSTITUTES_<YYYYMMDD>_<HHMMSS>.csv"
    };

    if (name === "data_type") {
      setNameType(nameTypeMapping[value]);
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      importData();
    }
  };

  const closeFormOnSuccess = () => {
    setShowImportDataForm(false);
    setDisableButton(false);
    let newDataType;
    switch (formData.data_type) {
      case "prices":
        newDataType = "Price";
        break;
      case "relatedproducts":
      case "accessories":
        newDataType = "Related Products";
        break;
      default:
        newDataType = formData.data_type.charAt(0).toUpperCase() + formData.data_type.slice(1)
    }
    props.setCurrentTab(newDataType);
  };

  const importData = async (data) => {
    setDisableButton(true);
    let res = await ServiceWrapper.doPost(
      `${MID_WAY_URL}connection/${appData?.channelKey}/import`,
      data ?? formData,
      null,
      AuthManager.getGmsToken()
    );

    if (res?.data?.done) {
      toast.success("Data Import initialized.");
      closeFormOnSuccess();
    } else {
      toast.error(res?.data?.message ?? "Data import failed.");
      setDisableButton(false);
    }
  };

  const validateForm = () => {
    if (formData.type === "" || formData.data_type === "") {
      toast.error("Import type, and Data type is mandatory.");
      return false;
    }
    return true;
  };

  return (
    <div className="ps-0 form-header">
      <div className="connection-container d-flex justify-content-between pe-3 ps-3">
        <span className="connection-text align-self-center fs-5  mb-0">
          Data Import
        </span>
        <button
          className="align-self-center border-0 btn fw fw-light mb-1 me-1 shadow-none"
          onClick={() => {
            setShowImportDataForm(false);
          }}
        >
          <img src={closeIcon} alt="Close icon" />
        </button>
      </div>

      <div className="px-3">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="type">Import Type</label>
            <select
              className="fst-normal p-2 border-1 form-select shadow-none drop-down-style"
              id="type"
              name="type"
              value={formData.type}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="Data file feed">Data file feed</option>
            </select>
          </div>
          <div className="form-group">
            <label htmlFor="dataType">Data Type</label>
            <select
              className="fst-normal p-2 border-1 form-select shadow-none drop-down-style"
              id="data_type"
              name="data_type"
              value={formData.data_type}
              onChange={handleChange}
            >
              <option value="">Select</option>
              {isNewVersion ?
                <option value="relatedproducts">Related Products</option> :
                <option value="accessories">Accessories</option>
              }
              <option value="availability">Availability</option>
              <option value="prices">Price</option>
              <option value="products">Products</option>
              <option value="orders">Orders</option>
              <option value="substitutes">Substitutes</option>

            </select>
          </div>

          <div className="form-group file-location">
            <label className="file-text"> File name</label>
            <label className="file-text">{nameType}</label>
          </div>

          {!showSchedule && (
            <div className="form-group d-flex">
              <GMSFillButton
                name="Import Now"
                disabled={disableButton}
                onClick={(e) => {
                  const triggerDataImportPermission =
                    appData.pm.checkPermission("connectionmanager_trigger");
                  if (triggerDataImportPermission) {
                    handleSubmit(e);
                  } else {
                    toast.info("You do not have permission to import data.");
                  }
                }}
              />
              <GMSButton
                name="Schedule"
                onClick={() => {
                  if (appData.pm.checkPermission("connectionmanager_trigger")) {
                    // enable schedule
                    setShowSchedule(true);
                  } else {
                    toast.info("You do not have permission to Schedule.");
                  }
                }}
              // disabled={true}
              />
            </div>
          )}
          {showSchedule && (
            <div className="form-group">
              <ScheduleForm
                validateForm={validateForm}
                setShowSchedule={setShowSchedule}
                formData={formData}
                fetchData={fetchData}
                submitForm={importData}
                closeForm={closeFormOnSuccess}
              />
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default DataImportForm;
